import React, { useState } from "react";
import { useModuleGate } from "../hooks/useModuleGate";

/**
 * LockedButton
 * Renders a normal button if user has ANY of the given codes.
 * If locked: button is rendered visually disabled, and hovering shows
 * an "Upgrade Plan" tooltip. The real onClick is suppressed.
 *
 * Usage:
 *   <LockedButton codes={[RECRUITMENT.VACANCIES_CREATE]} className="av-create-btn" onClick={() => setDrawerOpen(true)}>
 *     Create Vacancy
 *   </LockedButton>
 */
const LockedButton = ({
  codes = [],
  children,
  onClick,
  className = "",
  style = {},
  ...rest
}) => {
  const { hasAny } = useModuleGate();
  const [hovered, setHovered] = useState(false);
  const locked = !hasAny(codes);

  return (
    <div
      style={{ position: "relative", display: "inline-flex" }}
      onMouseEnter={() => locked && setHovered(true)}
      onMouseLeave={() => locked && setHovered(false)}
    >
      <button
        {...rest}
        className={`${className}${locked ? " locked-btn--disabled" : ""}`}
        style={{
          ...style,
          ...(locked
            ? {
                opacity: 0.45,
                cursor: "not-allowed",
                filter: "grayscale(0.4)",
                pointerEvents: "none",
              }
            : {}),
        }}
        onClick={locked ? undefined : onClick}
        disabled={locked || rest.disabled}
      >
        {locked && (
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            style={{ marginRight: 5, flexShrink: 0 }}
          >
            <rect
              x="2"
              y="5.5"
              width="9"
              height="6.5"
              rx="1.5"
              stroke="currentColor"
              strokeWidth="1.4"
            />
            <path
              d="M4.5 5.5V4a2 2 0 1 1 4 0v1.5"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
          </svg>
        )}
        {children}
      </button>

      {locked && hovered && (
        <div
          style={{
            position: "absolute",
            bottom: "calc(100% + 8px)",
            left: "50%",
            transform: "translateX(-50%)",
            whiteSpace: "nowrap",
            background: "#1e293b",
            color: "#fff",
            fontSize: 12,
            fontWeight: 500,
            padding: "6px 12px",
            borderRadius: 7,
            boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
            zIndex: 9999,
            pointerEvents: "none",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path
              d="M6.5 1.5l1.2 2.4 2.7.4-1.95 1.9.46 2.66L6.5 7.6 4.07 8.86l.46-2.66L2.6 4.3l2.7-.4L6.5 1.5z"
              stroke="#facc15"
              strokeWidth="1.2"
              strokeLinejoin="round"
              fill="#facc15"
            />
          </svg>
          Upgrade Plan to access this
          {/* Tooltip arrow */}
          <span
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "5px solid transparent",
              borderRight: "5px solid transparent",
              borderTop: "5px solid #1e293b",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default LockedButton;
